
<template>
  <div>
    <div class="semillWrap" style="margin-top: 20px; padding: 0 40px">
      <div style="width: 100%; float: left">
        <div style="padding: 10px 0 0 25px; box-sizing: border-box">
          <el-form label-position="left" label-width="85px" :model="THFdata">
            <el-form-item label="收货信息">
              <div class="block">
                FBA仓库编码：{{LocahouseDTO.recwarehouseDTO?LocahouseDTO.recwarehouseDTO.namec:''}}
                <div><span class="el-icon-location-information"></span>{{LocahouseDTO.recwarehouseDTO?LocahouseDTO.recwarehouseDTO.address:''}}</div>
              </div>
            </el-form-item>
            <el-form-item label="发货信息">
              <div class="block">
                <el-radio-group @change="changeTi" v-model="THFdata.checked">
                  <el-radio-button :label="true">上门取件</el-radio-button>
                  <el-radio-button :label="false">送货到仓</el-radio-button>
                </el-radio-group>
              </div>
            </el-form-item>
          </el-form>
          <el-form
            size="small"
            label-width="85px"
            label-position="left"
            :inline="true"
            class="demo-form-inline"
          >
            <el-row style="float: left" :gutter="20">
              <el-col :span="24" v-show="!THFdata.checked">
                <el-form-item label="送仓日期">
                  <div class="block">
                    <el-date-picker
                      @change="getInwarehousetime(inwarehousetime)"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      style="width: 344px"
                      v-model="inwarehousetime"
                      type="date"
                      placeholder="选择日期"
                      :picker-options="pickerOptions"
                    >
                    </el-date-picker>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-show="!THFdata.checked">
                <el-form-item label="仓库联系人">
                  <el-input
                    v-model="warehouseContactPerson"
                    disabled
                    style="width: 240px"
                    class="input-with-select"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-show="THFdata.checked">
                <el-form-item label="提货地点">
                  <el-input v-model="localaddress" style="width: 240px" class="input-with-select">
                    <el-button style="color: #FF4D01" @click="changeCheic()" slot="append">联系簿</el-button>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-show="!THFdata.checked">
                <el-form-item label="仓库地址">
                  <el-popover
                    placement="top-start"
                    title="仓库地址"
                    width="200"
                    trigger="hover"
                  >
                    <el-input
                      v-model="warehouseAddress"
                      disabled
                      slot="reference"
                      class="input-with-select"
                    ></el-input>
                  </el-popover>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-show="THFdata.checked">
                <el-form-item label="提货日期">
                  <el-date-picker
                    @change="gettodoorTime(todoorTime)"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    style="width: 220px"
                    v-model="todoorTime"
                    type="date"
                    placeholder="选择日期"
                    :picker-options="pickerOptions"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="发货联系人">
                  <el-input
                    v-model="countLIst_S.name"
                    style="width: 240px"
                    class="input-with-select"
                  >
                    <el-button
                      style="color: #FF4D01"
                      @click="getFadata()"
                      slot="append"
                      >联系簿</el-button
                    >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系电话">
                  <el-input v-model="countLIst_S.tel" class="input-with-select">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </div>
    <!-- 地址弹窗 -->
    <div class="dialogCover" @click.self="closeMyDialog()" v-if="showMydialog">
      <div class="myDialog">
        <!-- header  -->
        <div style="display: flex; justify-content: space-between">
          <span style="font-weight: 600">提货地址</span>
          <i
            class="el-icon-close"
            @click="closeMyDialog()"
            style="cursor: pointer"
          ></i>
        </div>
        <!-- body   -->
        <div>
          <div
            style="
              display: flex;
              justify-content: space-between;
              margin: 20px 0;
            "
          >
            <div>
              <el-input
                clearable
                @clear="getPeopletable()"
                v-model="nameOrPhone"
                @keyup.native="searchNameOrPhone"
                placeholder="请输入姓名或电话"
                size="medium"
                style="width: 250px"
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
                <el-button slot="append" type="primary">搜索</el-button>
              </el-input>
            </div>

            <el-button size="medium" plain type="primary" @click="showAdd(true)"
              >新增地址</el-button
            >
          </div>
          <!-- 新增或编辑 -->
          <div
            v-if="edit"
            style="
              background-color: #fff;
              border-radius: 20px;
              padding: 20px;
              box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.31);
            "
          >
            <div style="width: 85%; margin: 0 auto; max-width: 500px">
              <el-row
                :gutter="20"
                style="margin-bottom: 8px; margin-left: 1px; display: flex"
              >
                <div style="display: flex">
                  <div
                    class="grid-content"
                    style="margin-right: 35px; min-width: 50px"
                  >
                    <span style="line-height: 40px">联系人</span>
                  </div>

                  <div class="grid-content">
                    <el-input
                      v-model="submitForm.name"
                      placeholder="请输入联系人"
                    ></el-input>
                  </div>
                </div>
                <div style="display: flex">
                  <div
                    class="grid-content"
                    style="
                      margin-left: 10px;
                      margin-right: 10px;
                      min-width: 60px;
                    "
                  >
                    <span style="line-height: 40px">联系方式</span>
                  </div>

                  <div class="grid-content">
                    <el-input
                      v-model="submitForm.tel"
                      placeholder="请输入联系方式"
                    ></el-input>
                  </div>
                </div>
              </el-row>

              <el-row :gutter="20" style="margin-bottom: 8px">
                <el-col :span="4"
                  ><div class="grid-content">
                    <span style="line-height: 40px">联系地址</span>
                  </div></el-col
                >
                <el-col :span="18">
                  <div class="grid-content">
                    <el-cascader
                      :options="jackCitylist"
                      placeholder="请选择提货地址"
                      v-model="value"
                      clearable
                      @change="handleChange"
                      :props="props"
                    >
                    </el-cascader>
                  </div>
                </el-col>
              </el-row>

              <el-row :gutter="20" style="margin-bottom: 8px">
                <el-col :span="4"
                  ><div class="grid-content">
                    <div
                      style="line-height: 40px; width: 10px; height: 10px"
                    ></div></div
                ></el-col>
                <el-col :span="18"
                  ><div class="grid-content">
                    <el-input
                      v-model="submitForm.address"
                      type="textarea"
                      rows="2"
                      placeholder="请输入详细地址"
                    ></el-input></div
                ></el-col>
              </el-row>
              <el-row :gutter="20" style="margin-bottom: 8px">
                <el-col :span="4"
                  ><div class="grid-content">
                    <span style="line-height: 40px">标签</span>
                  </div></el-col
                >
                <el-col :span="18"
                  ><div class="grid-content">
                    <el-input
                      v-model="submitForm.tag"
                      placeholder="请输入标签"
                    ></el-input></div
                ></el-col>
              </el-row>

              <div style="width: 330px; margin: 0 auto; text-align: center">
                <div style="display: flex">
                  <el-checkbox
                    text-color="#FF4D01"
                    v-model="submitForm.isdefault"
                    style="margin-right: 10px"
                  ></el-checkbox>
                  <span style="display: block; margin-bottom: 8px">
                    设置为默认地址
                  </span>
                </div>
                <el-button
                  @click="addAddr"
                  style="
                    background: #FF4D01;
                    border: 1px solid #FF4D01;
                    border-radius: 5px;
                    color: #fff;
                  "
                  >{{ this.submitForm.id ? "修改" : "新增" }}</el-button
                >
                <el-button type="info" @click="showAdd(false)">关闭</el-button>
              </div>
            </div>
          </div>

          <el-table
            v-if="!edit"
            @row-click="rowClick"
            size="mini"
            height="300"
            tooltip-effect="dark"
            :data="tableData"
            max-height="200"
            highlight-current-row
            border
            ref="Table"
            style="width: 100%; overflow: hidden"
          >
            <el-table-column
              label="姓名"
              width="100"
              align="center"
              prop="name"
            >
            </el-table-column>
            <el-table-column label="电话" width="120" align="center" prop="tel">
            </el-table-column>
            <el-table-column
              label="联系地址"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                {{ scope.row.parvince }}
                {{ scope.row.city }}
                {{ scope.row.area }}
                {{ scope.row.address }}
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="160">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="mini"
                  @click.stop="setDefault(scope.row)"
                >
                  <span
                    :style="
                      scope.row.isdefault ? 'color:#FF4D01' : 'color:#9A9A9A'
                    "
                    >{{ scope.row.isdefault ? "默认" : "设为默认" }}</span
                  >
                </el-button>
                <el-button
                  size="mini"
                  type="text"
                  @click="handleEdit(scope.$index, scope.row)"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  size="mini"
                  @click.stop="DeleteTitem(scope.$index, scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-alert
            v-if="!edit"
            style="margin-top: 20px"
            title="点击任意一行选择您的地址"
            type="info"
            center
            show-icon
          >
          </el-alert>
        </div>
      </div>
    </div>
    <!-- 地址弹窗 END -->
    <!-- 发货人 -->
    <el-dialog title="发货联系人" :visible.sync="fashow">
      <div
        style="
          width: 100%;
          float: left;
          text-align: right;
          padding: 10px 25px;
          box-sizing: border-box;
        "
      >
        <el-button type="primary" @click="addNewpop()">新增地址</el-button>
      </div>
      <!-- FapopList -->
      <el-table size="mini" @row-click="rowFaset" :data="FapopList">
        <el-table-column
          property="name"
          label="姓名"
          width="200"
        ></el-table-column>
        <el-table-column property="tel" label="电话"></el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button @click.stop="UpItem(scope.row)" type="text" size="small"
              >修改</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-alert
        title="点击任意一行选择您的地址"
        center
        style="margin-top: 20px"
        show-icon
        :closable="false"
      ></el-alert>
    </el-dialog>
    <el-dialog
      class="dialog"
      :width="width"
      :visible.sync="fahuoShow"
      :closeOnClickModal="false"
    >
      <div class="wrap_count">
        <div class="fa_logo">
          {{ !this.itemid ? "新增地址" : "修改地址" }}
        </div>
        <div class="count">
          <el-form :label-position="labelPosition" label-width="80px">
            <el-form-item label="联系人">
              <el-input
                placeholder="请输入姓名"
                v-model="fromPop.name"
              ></el-input>
            </el-form-item>
            <el-form-item label="联系方式">
              <el-input
                placeholder="请输入联系方式"
                v-model="fromPop.tel"
              ></el-input>
            </el-form-item>
            <el-form-item prop="type">
              <el-checkbox-group v-model="fromPop.isdefault">
                <el-checkbox name="type">设置为默认地址</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">{{
                itemid ? "修改" : "确定新增"
              }}</el-button>
              <el-button @click="fahuoShow = false">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import qs from "qs";
import eventBus from './eventBus.js' 
export default {
   props: {
    LocahouseDTO: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      warehouseContactPerson:'',
      warehouseAddress:'',
      labelPosition: "left",
      props: {
        value: "namec",
        label: "namec",
      },
      jackCitylist: [],
      tableData: [],
      tempTableData: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      countLIst_S: {
        //发货
        address: "",
        city: "",
        country: "",
        customerid: "",
        id: "",
        isdefault: false,
        name: "",
        tag: "",
        tel: "",
      },
      localaddress:'',
      countLIst_T: {
        address:'',
        area:'',
        city:'',
        name:'',
        parvince:'',
        tel:'',
      },
      THFdata: {
        checked: true,
        feeCode: "THF",
        price: "",
        currency: "",
        cnyprice: "",
        cnycurrency: "",
        cnyamount: "",
        amount: "",
        piece: 1,
        minKilometer: "",
        maxKilometer: "",
      },
      nameOrPhone: "",
      todoorTime: "",
      showMydialog: false,
      edit: false,
      submitForm: {
        address: "",
        area: "",
        city: "",
        customerid: 0,
        id: 0,
        isdefault: false,
        name: "",
        parvince: "",
        tag: "",
        tel: "",
      },
      fashow: false,
      FapopList: [],
      fahuoShow: false,
      itemid: "",
      fromPop: {
        parvince: "",
        city: "",
        area: "",
        country: "",
        customerid: null,
        id: "",
        isdefault: true,
        name: "",
        tag: "",
        tel: "",
      },
      width: "420px",
      ssqnames:[],
      timeData:{
        todoorTime:'',
        inwarehousetime:''
      },
      inwarehousetime: "",
    };
  },
  watch: {
    'LocahouseDTO':function(val){
      
      this.THFdata.checked = val.isgetgoodstodoor //是否上门取件
      this.countLIst_T = val.deliveryFbxAddressDTO
      this.localaddress = this.countLIst_T?this.countLIst_T.parvince+this.countLIst_T.city +this.countLIst_T.area +this.countLIst_T.address:''
      this.countLIst_S.name = val.delgoodsname
      this.countLIst_S.tel = val.delgoodstel
      this.todoorTime = val.todoordate
      this.inwarehousetime = val.inwarehouseTime
      this.warehouseAddress = val.warehouseAddress
      this.warehouseContactPerson = val.warehouseContactPerson
    }
  },
  methods: {
    gettodoorTime(time){
      this.timeData.todoorTime = time
      this.$emit('getTime',this.timeData)
    },
    getInwarehousetime(time){
      this.timeData.inwarehousetime = time
      this.$emit('getTime',this.timeData)
    },
    UpItem(item){ //修改发货
      this.itemid = item.id;
      this.ssqnames = [];
      this.fahuoShow = true;
      this.fromPop = JSON.parse(JSON.stringify(item));
    },
    isPhone(num) {
      let mPattern = /^1[34578]\d{9}$/;
      return mPattern.test(num);
    },
    onSubmit() {
      //新增发货
      if (!this.isPhone(this.fromPop.tel))
        return this.$message({ message: "请输入正确的手机号码" });
      let params = {
        customerid: this.LocahouseDTO.customerid, //客户id
        id: this.itemid,
        isdefault: this.fromPop.isdefault,
        name: this.fromPop.name,
        tag: "",
        tel: this.fromPop.tel,
      };
      this.axios.post(`/customer/addOrUpdateShipper`, params).then((res) => {
        console.log(res);
        if (res.data.code == "200") {
          this.$message({ message: "成功", type: "success" });
          this.fahuoShow = false;
          this.getFadata();
        } else {
          this.$message(res.data.message);
        }
      });
    },
    rowFaset(e) {
      console.log("e: ", e);
      this.fashow = false;
      this.countLIst_S = e;
      this.$emit('getcountLIst_S',this.countLIst_S)
    },
    handleChange(value) {
      this.submitForm.parvince = value[0];
      this.submitForm.city = value[1];
      this.submitForm.area = value[2];
    },
    addNewpop() {
      this.fahuoShow = true;
      this.itemid = "";
      this.fromPop.name = "";
      this.fromPop.tel = "";
      this.ssqnames = [];
      this.fromPop.address = "";
    },
    closeMyDialog() {
      if (this.edit) {
        this.$confirm("当前为编辑状态,是否关闭?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.showMydialog = false;
            this.showAdd(false);
          })
          .catch((res) => {});
      } else {
        this.showMydialog = false;
      }
    },
    addAddr(id) {
      if (!this.very()) {
        return;
      }
      if (!this.submitForm.id) {
        delete this.submitForm.id;
      }
      // 新增
      this.submitForm.customerid = this.LocahouseDTO.customerid
      let path = "addOrUpdateDelivery";

      this.axios
        .post(`/customer/${path}`, this.submitForm, {})
        .then((res) => {
          if (res.data.code == 200) {
            this.edit = false;
            this.value = [];
            this.getPeopletable();
            for (let key in this.submitForm) {
              this.submitForm[key] = "";
            }
          } else {
            this.$message.info(res.data.message);
          }
        })
        .catch((res) => {});
    },

    // 点击行
    rowClick(r) {
      console.log('r: ', r);
      this.countLIst_T = r;
      this.localaddress = this.countLIst_T?this.countLIst_T.parvince+this.countLIst_T.city +this.countLIst_T.area +this.countLIst_T.address:''
      sessionStorage.setItem("countLIst_T", JSON.stringify(this.countLIst_T));
      this.showMydialog = false;
      this.$emit('GettodoorMoney',this.countLIst_T)//重新计算提货费
    },
    getPeopletable() {
      //获取提货联系人
      let that = this;
      this.axios
        .get(`/customer/addressListForFBADelivery/${this.LocahouseDTO.customerid}`)
        .then((res) => {
          if (res.data.code == "200") {
            this.tableData = res.data.datas;
            this.tempTableData = res.data.datas;
          } else {
          }
        })
        .catch((res) => {});
    },
    // 模糊搜索
    searchNameOrPhone() {
      if (!this.nameOrPhone) {
        return this.getPeopletable();
      }
      let temp = [];
      this.tempTableData.forEach((item, index) => {
        if (
          item.name.indexOf(this.nameOrPhone) != -1 ||
          item.tel.indexOf(this.nameOrPhone) != -1
        ) {
          temp.push(item);
        }
      });
      this.tableData = temp;
    },
    showAdd(type) {
      if (type) {
        this.edit = true;
      } else {
        this.edit = false;
      }

      this.value = [];
      for (let key in this.submitForm) {
        this.submitForm[key] = "";
      }
    },
    handleEdit(index, item) {
      this.value = [];
      let temp = JSON.stringify(item);
      this.submitForm = JSON.parse(temp);
      this.value.push(
        this.submitForm.parvince,
        this.submitForm.city,
        this.submitForm.area
      );
      this.edit = true;
    },
    changeCheic(type) {
      this.getPeopletable(); //获取提货联系人
      this.showMydialog = true;
    },

    getFadata() {
      //发货人
      let that = this;
      this.axios
        .get(`/customer/addressListForShipper/${this.LocahouseDTO.customerid}`)
        .then((res) => {
          if (res.data.code == "200") {
            this.FapopList = res.data.datas;
            this.fashow = true;
          } else {
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    changeTi() {
      console.log('this.THFdata.checked: ', this.THFdata.checked);
      this.THFdata.checked != this.THFdata.checked;
      eventBus.$emit('ChangeTHFtype',this.THFdata.checked)
      if (this.THFdata.checked) {
        this.$emit('GettodoorMoney',this.countLIst_T)//重新计算提货费
      }
    },
    // 校验
    very() {
      if (!this.submitForm.name) {
        this.$message.info("联系人不能为空！");
        return false;
      }
      if (!this.submitForm.tel) {
        this.$message.info("手机号不能为空！");
        return false;
      }
      // 城市
      if (!this.submitForm.city) {
        this.$message.info("联系地址不能为空！");
        return false;
      }
      // 区
      if (!this.submitForm.area) {
        this.$message.info("联系地址不能为空！");
        return false;
      }
      if (!this.submitForm.address) {
        this.$message.info("详细地址不能为空！");
        return false;
      }
      if (this.submitForm.tag) {
        if (this.submitForm.tag.length > 5) {
          this.$message.info("标签长度不能超过五个字符");
          return false;
        }
      }

      return true;
    },
    getPopList() {
      // 获取省市区列表
      let user = this.sessionGetUserInfo();
      this.axios
        .post(`/filedata/findDAndILevelAddress`, {}, {})
        .then((res) => {
          if (res.data.code == 200) {
            this.jackCitylist = res.data.datas;
          } else {
            this.$message.info("服务器繁忙");
          }
        })
        .catch((res) => {
          this.$message.info("服务器繁忙");
        });
    },
  },
  created() {
        // this.THFdata.checked
  },
  mounted() {
    this.getPopList();
    
  },
};
</script>
<style scoped>
.dialogCover {
  width: 100%;
  height: 100%;
  background-color: rgba(88, 85, 85, 0.37);
  margin: auto;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: fixed;
  z-index: 2000;
}
/* 弹窗 */
.myDialog {
  min-height: 350px;
  width: 50%;
  height: 50%;
  min-height: 400px;
  width: 50%;
  height: 50%;
  background-color: #fff;
  margin: auto;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: fixed;
  z-index: 2000;
  border-radius: 20px;
  padding: 20px;

  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.31);
}
</style>



// WEBPACK FOOTER //
// src/components/PersonalCenter/FBAheader/FBAChangedata/LocaText.vue